'use client';

import {
  ExpressiveButton,
  ExpressiveButtonProps,
} from '@exploration/shared-components';
import { useAuth } from '@thrivent-web/authentication';
import { useCallback } from 'react';

export const HeaderLoginButton = ({
  ...rest
}: Omit<ExpressiveButtonProps, 'children'>) => {
  const { signinRedirect, signoutSilent, isAuthenticated } = useAuth();

  const logInOrOut = useCallback(async () => {
    if (isAuthenticated) {
      await signoutSilent();
    } else {
      await signinRedirect();
    }
  }, [isAuthenticated, signinRedirect, signoutSilent]);

  return (
    <ExpressiveButton
      variant="tertiary"
      onClick={logInOrOut}
      size="default"
      data-analytics-id={isAuthenticated ? 'log-out' : 'log-in'}
      {...rest}
    >
      {isAuthenticated ? 'Log out' : 'Log in'}
    </ExpressiveButton>
  );
};
